/**
 * Expedienteitem Archetype
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeExpedienteitemCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Expedienteitem => Expedienteitem_hijo respectivamente.
 * @date May 22th, 2025
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date May 22th, 2025
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'Expedienteitem',
    baseIndex = baseController + '/index',
    archetype = () => {
        return [
            { key: 'id', type: 'hidden' },
            { key: 'expediente_version_id', type: 'hidden', label: 'Versión de Expediente' },
            { key: 'pregunta', type: 'textarea', label: 'Pregunta' },
            { key: 'pregunta_grupo', type: 'text', label: 'Grupo de Pregunta' },
            { key: 'tipo', type: 'select', label: 'Tipo', options: [
                'abierta',
                'opcional',
                'opcional_multiple',
                'fecha',
                'numero',
                'numero_positivo'
            ]},
            { key: 'unidades_numero', type: 'text', label: 'Unidad de Número' },
            { key: 'opciones', type: 'textarea', label: 'Opción' },
            { key: 'orden', type: 'select', label: 'Orden', options: Array.from({length: 25}, (_, i) => i + 1) },
            { key: 'created', type: 'datetime', label: 'Fecha de Creación', readonly: true },
            { key: 'modified', type: 'datetime', label: 'Fecha de Modificación', readonly: true }
        ]
    },
    captions = [
        // { key: 'expediente_version_id', label: 'Versión de Expediente' },
        { key: 'pregunta', label: 'Pregunta' },
        // { key: 'pregunta_grupo', label: 'Grupo de Pregunta' },
        { key: 'respuesta', label: 'Respuesta' },
        // { key: 'tipo', label: 'Tipo' },
        // { key: 'opciones', label: 'Opción' },
        // { key: 'orden', label: 'Orden' },
        // { key: 'unidades_numero', label: 'Unidad de Número' },
        // { key: 'created', label: 'Fecha de Creación' },
        // { key: 'modified', label: 'Fecha de Modificación' },
        // { key: '_' }
    ],
    estatusFilterSample = {
        key: 'estatus',
        required: false, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
        options: [
            'Activo',
            'Oculto'
            // { key: 'all', label: 'Todos' },
        ],
        default: null,
    },
    quicktableFilters = () => {
        return [
            // estatusFilterSample
        ]
    },
    archetypeExpedienteitemCFG = () => {
        return [
            // { key: 'id', type: 'hidden' },
            // { key: 'Expedienteitem_id', type: 'hidden', },
            // { key: 'descriptor', label: 'Description', readonly: true },
        ]
    };

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    captions,
    baseIndex,
    archetype, 
    archetypeExpedienteitemCFG, 
    quicktableFilters,
    automodalHandler
}